import secondaryComponents from "../../../secondaryComponents";
import useJournalLineTable from "./useJournalLineTable";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";

export const JournalLineTable = ({ journalEntryDetails }) => {
  const { instance } = useJournalLineTable({
    journalEntryDetails,
  });

  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <div className={`${globalStyles.tableWrapper} ${styles.lineTable}`}>
        {/* table section */}
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={`${styles.tableSection}`}
        >
          <div className="py-5 text-center">
            <h5>No journal line available</h5>
          </div>
        </secondaryComponents.TableHelper>
      </div>
    </>
  );
};
export default JournalLineTable;
